export default __webpack_public_path__ + "static/media/bankOfAmerica.97ed6203.png";